module.exports = __webpack_public_path__ + "static/android-chrome-192x192-d48bf5606611dc4453b8d5ba2dac789a.png";